import { ComboboxButton as HeadlessComboboxButton } from '@headlessui/react';
import { Icon } from '@src/components/Icon';
import { IconType } from '@src/IconType';
import { classNames } from '@src/utils/classNames';
import type { ComboboxMultipleProperties } from '../ComboboxMultiple';

type ComboboxDropDownButtonProperties<T> = Pick<
  ComboboxMultipleProperties<T>,
  'showDropdownButton' | 'buttonTestId'
> & { isOpen: boolean; setIsOpen: (isOpen: boolean) => void };

export function ComboboxDropDownButton<T>({
  showDropdownButton,
  buttonTestId,
  isOpen,
  setIsOpen,
}: ComboboxDropDownButtonProperties<T>) {
  if (!showDropdownButton) {
    return null;
  }

  return (
    <HeadlessComboboxButton
      className="absolute inset-y-0 right-3 flex items-center focus:outline-none"
      data-testid={buttonTestId ?? 'combobox-expand-btn'}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Icon
        type={isOpen ? IconType.ChevronUp : IconType.ChevronDown}
        className={classNames('h-6 w-6 text-gray-600')}
      />
    </HeadlessComboboxButton>
  );
}
